import React, {useEffect, useState} from "react";
import {withStyles} from "@material-ui/core";
import i18n from "../../../i18n";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import Button from "@material-ui/core/Button";
import FormSelect from "../../Form/FormSelect";
import Grid from "@material-ui/core/Grid/Grid";
import axios from "axios";
import CircularProgress from "@material-ui/core/CircularProgress";
import ReactDOM from "react-dom";
import _ from "lodash";

const formatGroupLabel = (data,classes) => (
    <div className={classes.group}>
        <span>{data.label}</span>
        {/*<span className={classes.groupBadge}>{data.options.length}</span>*/}
    </div>
);

const formatLabel = (type,option) => {
    let label = '';
    switch(type) {
        case 'week':
            label = 'KW ' + option;
            break;
        case 'month':
            label = i18n.get(
                'config.work_time.' +
                moment().month(option - 1 )
                    .format("MMMM")
                    .toLowerCase()
            )
            break;
    }
    return label;
}

const formatOptions = (type, key, options) => {
    if(options) {
        return options[key].map(option => {
            return {
                label: formatLabel(type,option),
                value: option,
                key: key,
            }
        })
    }
}

const formatGroupedOptions = (type, options) => {
    if(options) {
        return Object.keys(options).map( key => {
            return {
                label: key,
                options: options[key].map(option => {
                    return {
                        label: formatLabel(type,option),
                        value: option,
                        key: parseInt(key),
                    }
                }),
            }
        });
    }
}

const progress = () => {
    let wrapper = document.createElement('div');
    ReactDOM.render(
        <CircularProgress size={50} thickness={5} style={{'color': '#db2129'}} />,
        wrapper
    );
    let content = wrapper.firstChild;

    return swal({
        content: content,
        text:i18n.get('personnel.dialog.please_have_patience'),
        buttons:false,
        closeOnClickOutside: false,
        closeOnEsc: false,
    });
}


const sendData = async (values) => {

    let url = `personnel/export/working-times`;

    /*** show circular progress icon while rendering pdf */
    progress();

    await axios.post(url, values ,{responseType: 'arraybuffer'})
        .then((res) => {
            if (res.status === 204) {
                swal({
                    text: i18n.get('personnel.dialog.select_month'),
                    icon: "warning",
                    dangerMode: true
                });
            }

            if (res.status === 200) {
                const file = new Blob(
                    [res.data],
                    {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
                const fileURL = URL.createObjectURL(file);
                const link = document.createElement('a');
                link.href = fileURL
                link.download = res.headers['custom-filename'];
                link.click();
                swal.close();
            }
        }).catch(error => {
            console.error('error',error);
        });

}

const WorkingTimesExportDialog = (props) => {

    const {
        classes,
        open,
        handleClose,
        data,
    } = props;

    const { buildings } = data;

    const defaultValues = {
        building: null,
        start: '',
        end: '',
        year: null,
        month:null,
    };

    const [values,setValues] = useState(defaultValues);
    const [filter,setFilter] = useState(null);

    const setFieldValue = (field,value) => {
        values[field] = value;
        setValues({...values});
    }

    const changeFilter = id => {
        setFieldValue('building', id);
        let building = _.find( buildings, ['id', id]);
        setFilter( building ? building.print_filter : null  );
    }

    const closeDialog = () => {
        setValues(defaultValues);
        setFilter(null);
        handleClose();
    }

    const handleSubmit = () => {
        sendData( values ).then(res => {
            if(res) {
                closeDialog();
            }
        })
    }

    useEffect(() => {
        if (filter) {
            if(!values.year){
                ['start','end','year','month']
                    .map(field => setFieldValue(field, defaultValues[field]));
            }
        } else{
            setValues(defaultValues);
        }
    },[filter,values.year]);


    return (
        <Dialog open={open}
                onClose={closeDialog}
                disableBackdropClick={true}
                className={classes.dialog}
                fullWidth={true}
                maxWidth={'sm'}
                aria-labelledby="form-dialog-title">

            <DialogTitle id="form-dialog-title" className={classes.dialogTitle} disableTypography>
                <Typography variant="h6" color={"primary"}>
                    {i18n.get('personnel.dialog.export_filter')}
                </Typography>
                <IconButton aria-label="close" className={classes.closeButton} onClick={closeDialog}>
                    <Icon>close</Icon>
                </IconButton>{/**/}
                {/*<div style={{fontSize:18, color:'#999999'}}>
                    {/*i18n.get('building.site_journal.self',{building: building && building.name  })
                </div>
                <div style={{fontSize:11,color:'#999999'}}>
                    {i18n.get('building.site_journal.hints')}
                    <ul>
                        <li>{i18n.get('building.site_journal.hint_begin',{date: filter ? moment(filter.total_period.first_date ).format('DD.MM.YYYY') : ''})}</li>
                        <li>{i18n.get('building.site_journal.hint_end')}</li>
                    </ul>
                </div>*/}
            </DialogTitle>

            <DialogContent  className={classes.dialogContent}>

                <Grid spacing={8} container >

                    <Grid item xs={12}>
                        <FormSelect
                            type="text"
                            name="building"
                            label={i18n.get('personnel.dialog.construction_projects')}
                            onChange={option => {
                                changeFilter(option ? option.value : null);
                            }}
                            options={
                                buildings
                                    ? buildings.map( building => ({label:building.name, value:building.id}) )
                                    : ['']
                            }
                            value={values.building}
                            isClearable={true}
                            autoComplete={"off"}
                        />
                    </Grid>

                    {filter && (
                        <React.Fragment>

                            <Grid item xs={6}>
                                <FormSelect
                                    type="text"
                                    name="year"
                                    label={i18n.get('building.site_journal.year')}
                                    onChange={option => {
                                        setFieldValue('year', option ? option.value : null);
                                        setFieldValue('start',option ? option.value + '-01-01' : null);
                                        setFieldValue('end',option ? option.value + '-12-31' : null);
                                        if(!option) {
                                            ['month','week','start','end']
                                                .map(field => setFieldValue(field, defaultValues[field]))
                                        }
                                    }}
                                    options={
                                        filter
                                            ? filter.years.map(year => ({label:year, value:year}) )
                                            : ['']
                                    }
                                    value={values.year}
                                    isClearable={true}
                                    autoComplete={"off"}
                                />
                            </Grid>

                            <Grid item xs={6}>
                                <FormSelect
                                    type="text"
                                    name="month"
                                    label={i18n.get('building.site_journal.month')}
                                    onChange={option => {
                                        setFieldValue('year', option ? parseInt(option.key) : null);
                                        setFieldValue('month', option ? option.value : null);
                                        setFieldValue('start',option
                                            ? option.key + '-' + (option.value + '').padStart(2, '0') + '-01'
                                            : ''
                                        );
                                        setFieldValue('end',option
                                            ? moment().year(option.key).month(option.value - 1 ).endOf('month').format('YYYY-MM-DD')
                                            : ''
                                        );
                                        if(!option) {
                                            ['start','end']
                                                .map(field => setFieldValue(field, defaultValues[field]))
                                        }
                                    }}
                                    options={
                                        filter ? values.year
                                            ? formatOptions('month',values.year, filter.months_of_year)
                                            : formatGroupedOptions('month', filter.months_of_year)
                                            : ['']
                                    }
                                    formatGroupLabel={data => formatGroupLabel(data,classes)}
                                    value={values.month}
                                    isClearable={true}
                                    autoComplete={"off"}
                                />
                            </Grid>


                            {/*<Grid item xs={4}>
                                <FormSelect
                                    type="text"
                                    name="week"
                                    label={i18n.get('building.site_journal.week_of_year')}
                                    onChange={option => {
                                        setFieldValue('year', option ? parseInt(option.key) : values.year);
                                        setFieldValue('week', option ? option.value : null);
                                        setFieldValue('start', option
                                            ? moment().year(option.key)
                                                .isoWeek(option.value)
                                                .day(1)
                                                .format('YYYY-MM-DD')
                                            : '');
                                        setFieldValue('end', option
                                            ? moment().year(option.key)
                                                .isoWeek(option.value)
                                                .day(7)
                                                .format('YYYY-MM-DD')
                                            : '');
                                        if(option) {
                                            setFieldValue('month', null);
                                        } else {
                                            if(values.year) {

                                                setFieldValue('start', values.year + '-01-01');
                                                setFieldValue('end',values.year + '-12-31');
                                            } else {
                                                ['start','end']
                                                    .map(field => setFieldValue(field, defaultValues[field]))
                                            }
                                        }
                                    }}
                                    options={
                                        filter ? values.year
                                            ? formatOptions('week',values.year, filter.weeks_of_year)
                                            : formatGroupedOptions('week', filter.weeks_of_year)
                                            : ['']
                                    }
                                    value={values.week}
                                    isClearable={true}
                                    autoComplete={"off"}
                                />
                            </Grid>*/}

                        </React.Fragment>
                    )}
                </Grid>
            </DialogContent>
            {values.month && (
                <DialogActions className={classes.dialogActions}>
                    {/*<Button
                    component={'a'}
                    variant={'contained'}
                    color={'primary'}
                    size={'small'}
                    name={'preview'}
                    onClick={handleSubmit}
                >
                    {i18n.get('building.actions.print_preview')}
                </Button>*/}
                    <Button
                        component={'a'}
                        variant={'contained'}
                        color={'primary'}
                        size={'small'}
                        style={{marginLeft:10}}
                        name={'download'}
                        onClick={handleSubmit}
                    >
                        {i18n.get('personnel.dialog.download')}
                    </Button>
                </DialogActions>
            )}
        </Dialog>
    );

}

const styles = theme => ({
    dialog: {
        minHeight:700,
    },
    dialogTitle: {
        color: theme.colors.primary,
    },
    dialogContent: {
        overflow:'visible',
    },
    dialogActions: {
        paddingRight: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing.unit * 1.2,
        top: theme.spacing.unit * 2,
    },
    checkBoxDivider: {
        marginTop: '-0.7rem',
        marginBottom:0,
        backgroundColor:'rgba(0, 0, 0, 0.4)',
    },
    group: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    groupBadge: {
        backgroundColor: '#EBECF0',
        borderRadius: '2em',
        color: '#172B4D',
        display: 'inline-block',
        fontSize: 12,
        fontWeight: 'normal',
        lineHeight: '1',
        minWidth: 1,
        padding: '0.16666666666667em 0.5em',
        textAlign: 'center',
    }
});

export default withStyles(styles)(WorkingTimesExportDialog);
